const NETWORKS = {
  1: {
    chainId: 1,
    chainIdHex: '0x1',
    networkName: 'Ethereum Mainnet',
  },
  11155111: {
    chainId: 11155111,
    chainIdHex: '0xaa36a7',
    networkName: 'Sepolia',
    addChainParams: {
      chainId: '0xaa36a7',
      chainName: 'Sepolia',
      nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://ethereum-sepolia-rpc.publicnode.com'],
      blockExplorerUrls: ['https://sepolia.etherscan.io'],
    },
  },
}

export function normalizeChainId(chainId) {
  if (typeof chainId === 'number') return chainId
  const value = String(chainId || '')
    .trim()
    .toLowerCase()
  if (!value) return NaN
  return value.startsWith('0x') ? Number.parseInt(value, 16) : Number.parseInt(value, 10)
}

export function resolveConfiguredNetwork(config) {
  const chainId = normalizeChainId(config?.network?.chainId)
  if (!Number.isInteger(chainId) || chainId <= 0) {
    throw new Error('Wallet network configuration is invalid')
  }

  return (
    NETWORKS[chainId] || {
      chainId,
      chainIdHex: `0x${chainId.toString(16)}`,
      networkName: `Chain ${chainId}`,
    }
  )
}

export function isExpectedChain(currentChainId, expectedNetwork) {
  return normalizeChainId(currentChainId) === expectedNetwork.chainId
}
